export const L = (obj, lang) => (obj && (obj[lang] || obj.id || obj.en)) || "";

export const formatDateID = (iso, lang = "id") =>
  iso ? new Date(`${iso}T00:00:00`).toLocaleDateString(lang === "en" ? "en-GB" : "id-ID", { day: "numeric", month: "long", year: "numeric" }) : "";

export const ytEmbed = (url) => {
  const m = String(url || "").match(/(?:youtu\.be\/|v=|embed\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};
